<template>
  <div
    id="roadmap"
    class="roadmap-container"
  >
    <div class="roadmap-part-wrapper content-part-wrapper">
      <div class="roadmap-title-wrapper content-title-wrapper">
        <h3>{{$t('ROADMAP')}}</h3>
        <span class="title-line"></span>
      </div>
      <div class="roadmap-content-container">
        <img
          class="bg-image"
          src="../../assets/pageroadmap/bg.png"
        />
        <div class="roadmap-content">
          <span class="roadmap-line"></span>
          <ul class="roadmap-list">
            <li
              v-for="(item ,index) in roadmap"
              :class='"roadmap-item roadmap-item" + index'
              :style='"top: " + (30 + 74 * index) + "px"'
            >
              <div class="item-content">
                <p class="roadmap-introduction">
                  {{item.time}}，{{item.events}}
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

</template>

<i18n>
{
  "en": {
    "ROADMAP": "ROADMAP",
    "roadmap": [
        {
          "time": "Q2 2018",
          "events": "the BonusCloud Kick-off"
        },
        {
          "time": "Q3 2018",
          "events": "White Paper and BonusNet Beta"
        },
        {
          "time": "Q4 2018",
          "events": "BonusChain Kick-off"
        },
        {
          "time": "Q1 2019",
          "events": "BonusComputing Kick-off"
        },
        {
          "time": "Q1 2019",
          "events": "BonusChain Beta"
        },
        {
          "time": "Q2 2019",
          "events": "BonusNet 1.0 and BonusChain 1.0"
        },
        {
          "time": "Q3 2019",
          "events": "BonusStorage Kick-off"
        },
        {
          "time": "Q3 2019",
          "events": "BonusComputing Beta"
        },
        {
          "time": "Q4 2019",
          "events": "Full Function platform Kick-off"
        },
        {
          "time": "Q4 2019",
          "events": "BonusComputing 1.0 and BonusStorage Beta"
        },
        {
          "time": "Q1 2020",
          "events": "SDE，SDK and BonusStorage 1.0"
        }
      ]
  },
  "zn": {
    "ROADMAP": "路线图",
    "roadmap": [
        {
          "time": "Q2 2018",
          "events": "BonusCloud 启动"
        },
        {
          "time": "Q3 2018",
          "events": "白皮书 BonusNet Beta版本"
        },
        {
          "time": "Q4 2018",
          "events": "BonusChain 启动"
        },
        {
          "time": "Q1 2019",
          "events": "BonusComputing 启动"
        },
        {
          "time": "Q1 2019",
          "events": "BonusChain 测试链"
        },
        {
          "time": "Q2 2019",
          "events": "BonusNet 1.0版本 和 BonusComputing Beta版本"
        },
        {
          "time": "Q3 2019",
          "events": "BonusStorage 启动"
        },
        {
          "time": "Q3 2019",
          "events": "BonusComputing 1.0版本"
        },
        {
          "time": "Q4 2019",
          "events": "全功能平台启动"
        },
        {
          "time": "Q4 2019",
          "events": "BonusChain 1.0 和 BonusStorage Beta版本"
        },
        {
          "time": "Q1 2020",
          "events": "SDE，SDK 和 BonusStorage 1.0版本"
        }
      ]
  }
}
</i18n>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "PcLogin",
  props: {},
  data() {
    return {
      roadContentLenth: ""
    };
  },
  computed: mapState({
    roadmap() {
      return this.$t("roadmap");
    }
  }),
  methods: {
    ...mapActions([])
  },
  created() {
    let roadCount = this.roadmap.length;
    let top = 30;
    let interval = 60;
    let bottom = 50;
    let iconHeight = 14;

        this.$i18n.locale = this.isZnWebsite ? "zn" : "en";

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.roadmap-part-wrapper {
  padding: 20px 0 80px;
  // margin-bottom: 60px;

  .roadmap-content-container {
    width: 100%;

    img.bg-image {
      width: 65%;
      padding: 0 10%;
      margin-bottom: 50px;
    }
  }

  .roadmap-content {
    height: 820px;
    position: relative;
    margin: 0 17%;

    .roadmap-line {
      width: 1px;
      height: 100%;
      background-color: #fff;
      position: absolute;
      top: 0px;
      left: 0px;
    }

    .roadmap-item {
      position: absolute;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 14px;
      background-color: #266dea;
      left: -6px;

      .item-content {
        position: absolute;
        left: 50px;
        width: 600px;
      }

      .roadmap-time {
        font-size: 20px;
      }
    }
  }
}

@media (max-width: 720px) {
  .roadmap-part-wrapper {
    margin-bottom: 40px;

    .roadmap-content-container {
      img.bg-image {
        width: 100%;
        padding: 0;
        margin-bottom: 20px;
      }
    }

    .roadmap-content {
      margin: 0 6px;

      .roadmap-item {
        .item-content {
          max-width: 250px;
        }
      }
    }
  }
}
</style>
